import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { Moment } from 'moment';
import * as moment from 'moment';
import { environment } from 'src/environments/environment';
import { TranslateService } from '@ngx-translate/core';
import { RequestService } from 'src/app/shared/services/request.service';
import { SpinnerService } from 'src/app/shared/services/spinner.service';

@Component({
  selector: 'app-all',
  templateUrl: './all.component.html',
  styleUrls: ['./all.component.scss'],
  standalone: false
})
export class AllComponent implements OnInit {
  public currentDate: Moment = moment.utc();
  public identityName: string = environment.identityName;
  public organization: any = undefined;
  public orgList: any[] = [];

  constructor(
    private router: Router,
    private requestService: RequestService,
    private translate: TranslateService, private spinnerService: SpinnerService
  ) { }

  ngOnInit() {
    this.requestService.logout(false);
    this.fetchOrgs();
  }

  setOrganization(value) {
    this.organization = value;
    if (this.organization && this.organization.subdomain)
      window.location.href = this.organization.subdomain;
  }
  private fetchOrgs() {
    this.spinnerService.show();
    this.requestService.getDataL('organization', (data, error) => {
      if (error) {
        this.spinnerService.hide();
      }
      if (data && data.results && data.results.length > 0) {
        this.orgList = data.results;
        // this.orgList.push({
        //   name: "WRNA Temp", _id: '1234'
        // })
      }
      this.spinnerService.hide();
    });
  }
}
